import { getRuleErrorMessage, URLRegex } from "@/utils/formHelper";
import { qrListPickerValidations, qrNameValidation } from "./shared";
import { TFunction } from "i18next";

export const qrAppsValidation = (data, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "appsName",
      rules: {
        required: {
          value: true,
          message: getRuleErrorMessage("appsName", "required", data),
        },
        minLength: {
          value: 1,
          message: getRuleErrorMessage("appsName", "minLength", data),
        },
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("appsName", "maxLength", data),
        },
      },
    },
    {
      name: "appsCompany",
      rules: {
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("appsCompany", "maxLength", data),
        },
      },
    },
    {
      name: "appsDescription",
      rules: {
        maxLength: {
          value: 200,
          message: getRuleErrorMessage("appsDescription", "maxLength", data),
        },
      },
    },
    {
      name: "appsWebsite",
      rules: {
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("appsWebsite", "pattern", data),
        },
      },
    },
    ...qrListPickerValidations("social_invalid", t),
  ];
};
